module.exports = __webpack_public_path__ + "static/seal-4d5844b618ea5fd7cdd7af60fde652b7.svg";